export default "__VITE_ASSET__D20e7K0u__"